/* eslint-disable @typescript-eslint/no-explicit-any */

export const PUBLIC_URL = "../../public";
export const LOGIN_URL = "/login";
export const DEFAULT_ROUTE = "/";

const getEnvValue = (viteKey: string, kubeKey: string) => {
  const env = (import.meta as any).env as Record<string, string | undefined>;
  return (
    env[viteKey] ||
    env[kubeKey] ||
    (typeof process !== "undefined"
      ? (process.env as Record<string, string | undefined>)[kubeKey]
      : undefined) ||
    ""
  );
};

export const API_SERVER_URL = getEnvValue(
  "VITE_APP_API_SERVER_URL",
  "API_SERVER_URL",
);
export const MINIO_URL = getEnvValue("VITE_APP_MINIO_URL", "MINIO_URL");
export const ENCRYPTION_KEY = getEnvValue(
  "VITE_APP_ENCRYPTION_KEY",
  "ENCRYPTION_KEY",
);
export const NAMESPACE = getEnvValue("VITE_APP_NAMESPACE", "NAMESPACE");
